export interface CostPutRequest {
  id: number;
  costCategoryId: number;
  detail: string;
  date: string;
  price: number;
}

export const EmptyCostPutRequest: CostPutRequest = {
  id: 0,
  costCategoryId: 0,
  detail: '',
  date: '',
  price: 0,
};

export type EditModalItem = CostPutRequest & {
  category: string;
};
